import { ReportDefinition, TargetEntityType, ReportMetaDataContext } from "./reportMetaData";
import { Helper } from "../core/util/helper";
import { Grid } from "../core/components/grid";
import { HTTPService } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";
export default class AttachedEntityTypes extends React.Component<AttachedEntityTypesProps, AttachedEntityTypesState> {
    private gridOptions: kendo.ui.GridOptions;
    constructor(props: AttachedEntityTypesProps) {
        super(props);
        this.state = {
            currentEntityType: props.entity.TargetEntityType,
            gridData: [],
            selectedItem: null
        };
        if (Helper.hasValue(props.entity.TargetEntityType) && typeof props.entity.TargetEntityType != "string") {
            this.getGridData(true);
        }
        this.initApp();
    }

    private changeSelectedTargetEntityTypes = (dataItem: GridItem) => {
        let gridData = this.state.gridData;
        const index = gridData.findIndex(f => f.targetEntityType === dataItem.targetEntityType);
        gridData[index].selected = !dataItem.selected;
        this.setState({ gridData: gridData }, this.afterGridDataChanged);
    }

    private afterGridDataChanged = () => {
        const lst = this.state.gridData.filter(f => f.selected).map(item => { return item.targetEntityType });
        this.props.onChange(this.props.field, lst);
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "targetEntityTypeName",
                    title: this.props.context.translations["WebSMS.ReportMetadata.TargetEntityType"]
                },
                {
                    field: "selected",
                    title: this.props.context.translations["Standard.Selected"],
                    template: "# if(data.selected) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#",
                }
            ]
        }
    }

    private getGridData = (isInit: boolean = false) => {
        let callBack: (result: KeyValuePair<TargetEntityType, string>[]) => void;
        if (isInit) {
            callBack = (result) => {
                let gridData: GridItem[] = result.map(x => {
                    return {
                        targetEntityType: x.Key,
                        targetEntityTypeName: x.Value,
                        selected: this.props.value.findIndex(f => f === x.Key) > -1
                    }
                });
                if (gridData.filter(f => f.selected).length === 0) {
                    const index = gridData.findIndex(f => f.targetEntityType === this.state.currentEntityType);
                    gridData[index].selected = true;
                }
                this.setState({ gridData: gridData }, this.afterGridDataChanged)
            }
        } else {
            callBack = (result) => {
                let gridData: GridItem[] = result.map(x => {
                    return {
                        targetEntityType: x.Key,
                        targetEntityTypeName: x.Value,
                        selected: x.Key === this.state.currentEntityType
                    }
                });
                this.setState({ gridData: gridData }, this.afterGridDataChanged)
            }
        }
        if (typeof this.state.currentEntityType !== "string")
            HTTPService.get<KeyValuePair<TargetEntityType, string>[]>(`ReportMetaData/GetPossibleTargetEntityTypes?targetEntityType=${this.state.currentEntityType}`).then(callBack);
    }

    private createGrid = () => {
        const buttonEnabled = Helper.hasValue(this.state.selectedItem) && !this.props.disabled;
        const buttonMode = (Helper.hasValue(this.state.selectedItem) && this.state.selectedItem.selected) ? "remove" : "add";
        let customButtons: Array<GridCustomToolBarButton> = [
            {
                autoEnabledOnRecordSelected: true,
                caption: (buttonMode === "add") ? Config.translations.add : Config.translations.delete,
                enabled: buttonEnabled,
                iconClass: (buttonMode === "add") ? "k-i-check" : "k-i-close", 
                id: "switchSelectedState"
            }
        ];
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="attachedEntityTypes"
                    onSelectionChanged={this.onSelectionChanged}
                    customButtons={customButtons}
                    onClickCustomButton={this.onCustomButtonClick}
            />
            </div>
        );
    }

    private onCustomButtonClick = (id: string, dataItem: GridItem) => {
        switch (id) {
            case "switchSelectedState":
                if (!dataItem.selected) {
                    this.changeSelectedTargetEntityTypes(dataItem);
                } else {
                    const count = this.state.gridData.filter(f => f.selected).length;
                    if (count === 1) {
                        NotificationHelper.showInfoMessage(this.props.context.translations["WebSMS.ReportMetadata.AtLeastOneTargetEntityType"]);
                    } else {
                        this.changeSelectedTargetEntityTypes(dataItem);
                    }
                }
                break;
        }
    }

    private onSelectionChanged = (dataItem: GridItem) => {
        this.setState({ selectedItem: dataItem });
    }

    componentDidUpdate() {
        if (this.state.currentEntityType != this.props.entity.TargetEntityType) {
            this.setState({ currentEntityType: this.props.entity.TargetEntityType }, this.getGridData)
       }
    }

    render() {
        if (typeof this.state.currentEntityType !== "string" && Helper.hasValue(this.state.currentEntityType)) {
            return this.createGrid();
        } else {
            return null;
        }
    }
}

interface AttachedEntityTypesProps extends BaseComponentProps{
    entity: ReportDefinition;
    value: TargetEntityType[];
    context: ReportMetaDataContext;
}

interface AttachedEntityTypesState {
    currentEntityType: TargetEntityType;
    gridData: GridItem[];
    selectedItem: GridItem;
}

interface GridItem {
    targetEntityType: TargetEntityType,
    targetEntityTypeName: string,
    selected: boolean
}

